import {Body} from "@irati/ui/src/Typography"
import React from "react"
import styled from "styled-components"

interface StoreGridProps {
  children: React.ReactNode
  totalEntries: number
}

export const StoreGrid = ({children, totalEntries}: StoreGridProps) => {
  const searchParams = new URLSearchParams(window.location.search)
  const resultsPerPage = searchParams.get("results_per_page") || "40"
  let currentPage = Number(searchParams.get("page"))
  currentPage = currentPage === 0 ? 1 : currentPage

  const resultsPerPageNumber = Number(resultsPerPage)

  const currentShowingNumber = ` ${currentPage === 1 ? 1 : (currentPage - 1) * resultsPerPageNumber + 1} - ${
    currentPage * resultsPerPageNumber < totalEntries ? currentPage * resultsPerPageNumber : totalEntries
  } of ${totalEntries} `

  return (
    <>
      <Result>
        Showing <strong>{currentShowingNumber}</strong> results
      </Result>
      <Grid>
        <GridContainer>{children}</GridContainer>
      </Grid>
    </>
  )
}

const Result = styled(Body)`
  font-size: 14px;
  color: ${({theme}) => theme.colors.greys.black};
`

const Grid = styled.div`
  flex-grow: 1;
  position: relative;
  min-height: 100vh;
  margin: 0;
  margin-bottom: ${({theme}) => theme.spacing.three};

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    margin: ${theme.spacing.three};
  `}
`

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(140px, 1fr));
  gap: ${({theme}) => theme.spacing.two} ${({theme}) => theme.spacing.one};
  margin: ${({theme}) => theme.spacing.three} auto 0;
  justify-items: center;

  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: ${theme.spacing.four} ${theme.spacing.two};
    `}

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    grid-template-columns: repeat(4, minmax(200px, 1fr));
    gap: ${theme.spacing.four};
  `}
`
